import { useSyncExternalStore } from 'react';
import { getTheme, subscribeTheme, type Theme } from '@/lib/theme';

/**
 * Reactive accessor for the current theme (dark | light). Re-renders the
 * consuming component whenever the theme changes. Mirror of useSkin.
 */
export function useTheme(): Theme {
  return useSyncExternalStore(
    (cb) => subscribeTheme(() => cb()),
    getTheme,
    getTheme,
  );
}
